import { compute, span } from "@/components/home/calculator/calc";

export const CalcTable = ({ price, fee, pcts }) => (
  <div className="overflow-x-auto rounded-2xl border border-border" data-testid="calculator-table">
    <table className="w-full text-xs sm:text-sm">
      <thead className="bg-secondary text-left">
        <tr>
          <th className="px-2 sm:px-4 py-3 font-bold">Lbs</th>
          <th className="px-2 sm:px-4 py-3 font-bold whitespace-nowrap">Paying now</th>
          <th className="px-2 sm:px-4 py-3 font-bold whitespace-nowrap"><span className="sm:hidden">Through us</span><span className="hidden sm:inline">Through I'm The Plug Now</span></th>
          <th className="px-2 sm:px-4 py-3 font-bold whitespace-nowrap">You save</th>
        </tr>
      </thead>
      <tbody>
        {[1, 5, 10, 25, 50].map((l) => {
          const r = compute(price, l, fee, pcts);
          return (
            <tr key={l} className="border-t border-border" data-testid={`calculator-table-row-${l}`}>
              <td className="px-2 sm:px-4 py-3 font-bold">{l}</td>
              <td className="px-2 sm:px-4 py-3 sm:whitespace-nowrap">{span(r, "totalNow")}</td>
              <td className="px-2 sm:px-4 py-3 sm:whitespace-nowrap">{span(r, "totalUs")}</td>
              <td className="px-2 sm:px-4 py-3 sm:whitespace-nowrap font-bold text-primary">{span(r, "savings")}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);
